import { useState, useEffect, useCallback } from "react";
import GET from "../utils/GET";
import message from "../utils/message";

const useResource = (initalUrl = false, initalOptions = {}, auto = true) => {
	const [url, setUrl] = useState(initalUrl);
	const [options, setOptions] = useState(initalOptions);

	const [shouldLoad, setShouldLoad] = useState(auto);
	const [resource, setResource] = useState({
		loading: false,
		error: false,
		data: null,
	});

	const reset = useCallback(
		() => setResource({ loading: false, error: false, data: null }),
		[]
	);

	useEffect(() => {
		const load = async () => {
			let response;

			if (!url) {
				return setResource({
					loading: false,
					error: false,
					data: null,
				});
			}

			setResource({
				loading: true,
				error: false,
				data: null,
			});

			try {
				response = await fetch(url, {
					...options,
				});
				if (response.status !== 200 && response.status !== 201) {
					throw new Error("RESP_ERR");
				}
				try {
					response = await response.json();
				} catch (error) {
					throw new Error("JSON_ERR");
				}
			} catch ({ message: errMessage }) {
				message({
					type: "WIDGET_REQUEST_COMPLETE",
					payload: {
						overlay: GET("desktopOverlay"),
						error: true,
					},
				});
				return setResource({
					loading: false,
					error:
						errMessage === "RESP_ERR" || errMessage === "JSON_ERR"
							? "An unknown error occured"
							: "Could not connect to the server",
					data: null,
				});
			}
			message({
				type: "WIDGET_REQUEST_COMPLETE",
				payload: {
					overlay: GET("desktopOverlay"),
				},
			});
			setResource({
				loading: false,
				error: false,
				data: response,
			});
		};
		if (shouldLoad) {
			setShouldLoad(false);
			load();
		}
	}, [url, options, shouldLoad]);

	const reload = useCallback(() => {
		message({
			type: "WIDGET_REQUEST_LOADING",
			payload: {
				overlay: GET("desktopOverlay"),
			},
		});
		setShouldLoad(true);
	}, []);

	return [resource, reload, setUrl, setOptions, reset];
};

export default useResource;
